import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA4_ID;

let loaded = false;
function loadGA() {
    if (loaded || !GA_ID) return;
    loaded = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: false });
}

export default function Analytics() {
    const { pathname, search } = useLocation();

    useEffect(() => { loadGA(); }, []);
    useEffect(() => {
        if (!GA_ID || !window.gtag) return;
        window.gtag("event", "page_view", {
            page_path: pathname + search,
            page_location: window.location.href,
            page_title: document.title,
        });
    }, [pathname, search]);
    return null;
}
